import { PaymentSmeGroupList } from './PaymentSmeGroupList';

export * from './PaymentGroupEdit';
export * from './PaymentGroupList';

export const PaymentGroupList = PaymentSmeGroupList;
